import React, { useEffect, useState, useRef } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import {
  selectSelected,
  fetchDetailId,
  selectDataId,
  selectLoading,
} from "./reportDetailSlice";
import { useHistory, useParams } from "react-router-dom";
import {
  formatDate,
  formatDateTime,
  CrprgpStatus,
  formatCurrency,
  showDialog,
  yesStatus,
  formatDateTimeUtc,
} from "../../../utility";

import { editItem } from "../../fss-asm-bm/fssSlice";
import { LayoutSplashScreen } from "../../../../_metronic/layout";

import WarningIcon from "@material-ui/icons/Warning";
import ImageIcon from "@material-ui/icons/Image";
import { selectUser } from "../../../modules/Auth/_redux/authRedux";
import { useSelector, useDispatch } from "react-redux";
import { showSuccessDialog, showErrorDialog } from "../../../utility";
import { useReactToPrint } from "react-to-print";

export const ReportDetail = () => {
  const history = useHistory();
  const items = useSelector(selectDataId);
  const loading = useSelector(selectLoading);
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const [qty, setQty] = useState("");

  console.log(items, "items");
  const conponentPDF = useRef();

  const { id } = useParams();

  // Return if data null
  // if (items === null) {
  //   history.push("/report-return/report-detail");
  // }

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      await callApiId(id);
    }
    fetchMyAPI();
  }, [dispatch]);

  const callApiId = async (id) => {
    try {
      const response = await dispatch(fetchDetailId(id));
      if (response.payload.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      // showErrorDialog("Something went wrong!");
    }
  };

  useEffect(() => {
    if (items !== null) {
      setQty(items.return_qty);
    }
  }, [items]);

  console.log(qty);

  const editAllowed = ["ADMIN", "SALES_SERVICE", "ADMINISTRATOR"];

  const role = user.roles.map((e) => {
    return e.roleName;
  });

  const checkRoles = (userRoles, allowedRoles) => {
    return userRoles.some((e) => allowedRoles.includes(e));
  };

  const handleSave = async () => {
    if (parseFloat(qty) > parseFloat(items.available_qty)) {
      return showErrorDialog(
        `Can't be bigger than available Qty ${items.available_qty}`
      );
    }
    if (parseFloat(qty) <= 0) {
      return showErrorDialog("can't be less than zero");
    }
    const id = items.returnd_id;
    const retNumber = items.ret_number;
    const params = {
      qty: qty,
    };
    try {
      const response = await dispatch(editItem({ id, params }));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.message);
        if (action.isConfirmed)
          history.push(`/report-return/report-detail/${retNumber}`);
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "ReportDetail",
    // onAfterPrint: () => alert("Data saved in PDF"),
  });

  return loading ? (
    <LayoutSplashScreen />
  ) : items === null ? null : (
    <Card>
      <CardHeader title="Report Return Detail">
        <CardHeaderToolbar>
          <Button className="btn btn-primary" onClick={generatePDF}>
            PDF
          </Button>
        </CardHeaderToolbar>
      </CardHeader>
      <div ref={conponentPDF}>
        <CardBody>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>APL Return Number </b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.ret_number} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>RTV No</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.rtv_no} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>RTV Date</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={formatDate(items.rtv_date)} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>RTV Receiving date</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      disabled
                      value={formatDate(items.rtv_receiving_date)}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Sales Office</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.sales_office} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Plant Code</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.plant_code} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Plant Name</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.plant_name} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Customer Code </b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.customer_code} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Customer Name</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.customer_name} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Invoice Ref Number</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.line} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Invoice Line Number</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.invoice_ref_no} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>SAP Sales Order</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.soNo} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>SAP INV Return</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.invoiceReturnNo} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Return Reason</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.reason_name} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Create Date Time</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      disabled
                      value={formatDateTime(items.create_datetime)}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Client Code</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.client_code} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Client Name</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.client_name} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Material Code</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.material_code} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Material Description</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.material_name} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Material Remarks</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      as="textarea"
                      style={{ height: "70px" }}
                      disabled
                      value={items.material_remarks}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Division</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.division} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>PH3</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.PH3} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Non Fraction</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      disabled
                      value={yesStatus(items.non_fraction)}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Requested Quantity</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.actual_qty} />
                  </Col>
                </Form.Group>
                {checkRoles(role, editAllowed) && (
                  <>
                    {items.step_code === "CD" &&
                      items.sales_approval_status === null &&
                      items.approvalBRQA === null &&
                      items.client_approval_status === null && (
                        <Form.Group as={Row}>
                          <Form.Label column sm={3}>
                            <b>Change Qty</b>
                          </Form.Label>
                          <Col sm={8}>
                            <Form.Control
                              onChange={(e) => {
                                setQty(e.target.value);
                              }}
                              value={qty}
                              type="number"
                            />
                          </Col>
                        </Form.Group>
                      )}
                    {items.step_code === "SALES" && (
                      <Form.Group as={Row}>
                        <Form.Label column sm={3}>
                          <b>Change Qty</b>
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            onChange={(e) => {
                              setQty(e.target.value);
                            }}
                            value={qty}
                            type="number"
                          />
                        </Col>
                      </Form.Group>
                    )}
                    {items.step_code === "BRQA" && (
                      <Form.Group as={Row}>
                        <Form.Label column sm={3}>
                          <b>Change Qty</b>
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            onChange={(e) => {
                              setQty(e.target.value);
                            }}
                            value={qty}
                            type="number"
                          />
                        </Col>
                      </Form.Group>
                    )}
                  </>
                )}

                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Return Uom</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.return_uom} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Base Uom</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.base_uom} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Net Price</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      disabled
                      value={formatCurrency(items.net_price)}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Batch</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.batch} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Exp Date</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={formatDate(items.exp_date)} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Sloc</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.sloc} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Type Prod</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.type_prod} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Temp</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.temp} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>SO Created</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.soNo} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>LT - Sales Approval</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.lt_sales} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>LT - Client Approval</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.lt_client} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>LT - Chief Delivery</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.lt_cd} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>LT - Chief Warehouse</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.lt_cw} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Overall Leadtime</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.overall_leadtime} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Attachment File</b>
                  </Form.Label>
                  <Col sm={8}>
                    {items.attachment_id === "" && (
                      <Button
                        variant="secondary"
                        size="sm"
                        className="mr-3"
                        active
                      >
                        <WarningIcon
                          onClick={(e) => {
                            showDialog(
                              "No image attached!",
                              "No Image",
                              "error"
                            );
                          }}
                          style={{ color: "#648DAE", margin: "5px" }}
                        />
                      </Button>
                    )}
                    {items.attachment_id !== "" && (
                      <Button
                        variant="secondary"
                        size="sm"
                        className="mr-3"
                        active
                      >
                        <ImageIcon
                          onClick={() => {
                            const url = `${process.env.REACT_APP_API_URL}/return/attachment/${items.attachment_id}`;
                            window.open(url, "_blank").focus();
                          }}
                          style={{ color: "#648DAE", margin: "5px" }}
                        />
                      </Button>
                    )}
                  </Col>
                </Form.Group>
              </Col>
              {/* Row kiri */}
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Actual Qty</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.return_qty} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Actual Uom</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.return_uom} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Material Status</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.material_status} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Fullbox Client</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.non_fraction} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>CRP Before</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.crp_before} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>CRP After</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.crp_after} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>CRP Status when iReturn Created</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={CrprgpStatus(items.crprgp)} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>CRP Remaning Days</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.remaing} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>FSS/ASM/NSM/BM User Name</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.sales_approval_user} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>FSS/ASM/NSM/BM Approval Date Time</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      disabled
                      value={formatDateTimeUtc(items.sales_approval_time)}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>FSS/ASM/NSM/BM Approval Status</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      disabled
                      value={items.sales_approval_status}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>FSS/ASM/NSM/BM Remarks</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.sales_remarks} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>BRQA Approval Name</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      disabled
                      value={items.approvalBRQA_user_name}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>BRQA Approval Date time</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      disabled
                      value={formatDateTimeUtc(items.approvalBRQA_date)}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>BRQA Approval Status</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.approvalBRQA} />
                  </Col>
                </Form.Group>

                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>BRQA Remarks</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.approvalBRQA_remarks} />
                  </Col>
                </Form.Group>

                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Client Approval Name</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.client_approval_user} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Client Approval Date Time</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      disabled
                      value={formatDateTimeUtc(items.client_approval_time)}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Client Approval Status</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      disabled
                      value={items.client_approval_status}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Client Remarks</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.client_remarks} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>QA HO Approval Name</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      disabled
                      value={items.approvalQAHO_user_name}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>QA HO Approval Date Time</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      disabled
                      value={formatDateTimeUtc(items.approvalQAHO_date)}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>QA HO Approval Status</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.approvalQAHO} />
                  </Col>
                </Form.Group>

                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>QA HO Remarks</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.approvalQAHO_remarks} />
                  </Col>
                </Form.Group>

                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>QA Client Approval Name</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      disabled
                      value={items.approvalQACLIENT_user_name}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>QA Client Approval Date Time</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      disabled
                      value={formatDateTimeUtc(items.approvalQACLIENT_date)}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>QA CLIENT Approval status</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.approvalQACLIENT} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>QA CLIENT Remarks</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      disabled
                      value={items.approvalQACLIENT_remarks}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Last FPRE Printed Date Time</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      disabled
                      value={formatDateTime(items.last_printed_datetime)}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Chief Warehouse Approval Name</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.cw_approval_user} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Chief Warehouse Approval Date Time</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      disabled
                      value={formatDateTimeUtc(items.cw_approval_time)}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Chief Warehouse Approval status</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.cw_approval_status} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Chief Warehouse Remarks</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control disabled value={items.cw_remarks} />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Chief Warehouse Complete Date time</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      disabled
                      value={formatDateTimeUtc(items.cw_approval_time)}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* end kiri */}
            </Form.Group>
          </Form>
          <Row className="mt-6">
            <Button
              variant="light"
              className="mr-3"
              onClick={() =>
                history.push(`/report-return/report-detail/${items.ret_number}`)
              }
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>

            {items.step_code === "SALES" && (
              <Button
                variant="success"
                className="mr-3"
                onClick={() => handleSave()}
              >
                Save
              </Button>
            )}
            {items.step_code === "BRQA" && (
              <Button
                variant="success"
                className="mr-3"
                onClick={() => handleSave()}
              >
                Save
              </Button>
            )}
            {items.step_code === "CD" &&
              items.sales_approval_status === null &&
              items.approvalBRQA === null &&
              items.client_approval_status === null && (
                <Button
                  variant="success"
                  className="mr-3"
                  onClick={() => handleSave()}
                >
                  Save
                </Button>
              )}
          </Row>
        </CardBody>
      </div>
    </Card>
  );
};
